

export class ImageUtil {


    public static makeHexColorImage = (color: string) => {
        const canvas = document.createElement('canvas');
        canvas.style.display = 'none';
        canvas.width = 32;
        canvas.height = 32;
        const context = canvas.getContext('2d');
        if (context) {
            context.fillStyle = color;
            context.fillRect(0, 0, canvas.width, canvas.height);
            const data = canvas.toDataURL();
            return data;
        } else {
            return "";
        }
    }
}